import * as React from 'react';

function SvgCheckmark(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 12" {...props}>
    <path
      stroke="#FF3E45"
      strokeLinecap="square"
      strokeMiterlimit={10}
      strokeWidth={3}
      d="M11 3 5.667 9 3 6.467"
    />
  </svg>)
}
export default SvgCheckmark;
